import { useEffect, useState } from "react";
import ITest from "../../types/ITest";
import { getQuizes } from "../../services/test.service";
import useAlerts from "../../hooks/useAlerts";
import UserTestsList from "../user/components/UserTestsList";

export default function QuizesAll(): JSX.Element {
  const { error } = useAlerts();

  const [tests, setTests] = useState<ITest[]>();

  useEffect(() => {
    getQuizes()
      .then(({ data }) => {
        setTests(data);
      })
      .catch((err) => {
        if (err.response.status !== 401) {
          error();
        }
      });
  }, []);

  return <UserTestsList tests={tests} isQuiz={true} />;
}
